import React from 'react';
import { ComingSoon } from '@/components/common/ComingSoon';

const WarrantyClaimsPage = () => {
  return <ComingSoon title="Warranty Claims & Authorizations" />;
};

export default WarrantyClaimsPage;
